import { ReactNode } from 'react'

import { Alert, AlertProps, AlertTitle, SxProps, useTheme } from '@mui/material'

type Props = {
	icon?: ReactNode
	title?: string
	sx?: SxProps
}

/**
 * Displays an alert for use as a general tooltip with an optional icon and title.
 */
export default function Callout({
	icon = null,
	title = null,
	sx = {},
	children = null,
	...rest
}: Props & AlertProps) {
	const theme = useTheme()
	return (
		<Alert
			sx={{
				'& .MuiAlert-icon': {
					color: theme.palette.grey[700],
				},
				'& .MuiAlert-message': {
					width: '100%',
				},

				backgroundColor: theme.palette.grey[200],
				color: theme.palette.text.primary,
				...sx,
			}}
			icon={icon || false}
			{...rest}
		>
			{title && <AlertTitle>{title}</AlertTitle>}
			{children}
		</Alert>
	)
}
